import {useForm} from "antd/es/form/Form";
import api from "../../api";
import {Button, Form, Input, message, Steps} from "antd";
import {getDescription, getIcon} from "./WorkflowVisualization";
import TextArea from "antd/es/input/TextArea";
import React, {useEffect, useState} from "react";
import {ModalWindow} from "../helpers/modals/ModalWindow";

export function TasksViewer ({current, userTasks, isAdmin, onApprove, userInfo, projectId, itemInfo}) {

    const [form] = useForm()
    const [currentStep, setCurrentStep] = useState([])
    const [show, setShow] = React.useState(false);
    const [actionType, setActionType] = React.useState("");

    useEffect(() => {
        setCurrentStep(prepare())
        form.resetFields()
    }, [current, userTasks])

    const approveStep = (task) => {
        message.info('Start approving the step')
        const data = {
            'action': task.step_type,
            user: userInfo['email'],
            position: task.position,
            status: 'done',
        }
        doAction(data, task)
    }

    const rejectStep = (task) => {
        message.info('Start rejecting the step')
        const data = {
            'action': "reject",

        }
        doAction(data, task)
    }

    const doAction = (data, task) => {
        const taskData = {
            task_id: task.task_id,
            step: task.step,
            workflow_id: task.workflow_id,
            object: task.object,
            object_type: task.object_type,
            email_cc: [],
            project_id: projectId,
            material_object_id: itemInfo['_id'],
            comment: form.getFieldValue('comment')
        }

        api.post(`/tasks/actions`, {...taskData, ...data })
            .then(json => {
                message.success(json.data)
                onApprove()
            })
            .catch(error => {
                onApprove()
            })
    }

    const cancelStep = (task) => {
        message.info('Start canceling the workflow')
        const data = {
            'action': "cancel",
        }
        doAction(data, task)
    }

    const checkIfCanApproveSingle = (task) => {
        let tasksForUser = userTasks.filter(t => (t.step_type !== 'acknowledge') && (t.status === 'active'))

        return !!tasksForUser.find(t => (t.task_id === task.task_id) && (t.step === task.step) && (t.user === task.user))
    }

    const arrayEquals = (a, b) => {
        return Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            a.every((val, index) => val === b[index]);
    }

    const checkIfCanApproveMultiple = (task) => {
        let tasksForUser = userTasks.filter(t => (t.step_type !== 'acknowledge') && (t.status === 'active'))
        return !!tasksForUser.find(t => (t.task_id === task.task_id) && (t.step === task.step) && (arrayEquals(task.user, t.user)))
    }

    const getUserDescription = (task) => {
        if (typeof task.user === 'string') {

            const canApprove = checkIfCanApproveSingle(task)

            return <p style={{color: 'black'}}>
                <div>
                    {getDescription(task)}
                </div>
                {canApprove &&
                <div>

                    <Form form={form}>
                        <Form.Item label={'Input the comment'} name={'comment'}>
                            <TextArea />
                        </Form.Item>
                    </Form>
                    <Button onClick={() => approveStep(task)}>Approve</Button>

                    {task.step === 0
                        ? <Button style={{marginLeft: 10}} onClick={() => cancelStep(task)}>Cancel</Button>
                        : <Button style={{marginLeft: 10}} onClick={() => rejectStep(task)}>Reject</Button>
                    }
                </div>}
            </p>
        } else if (Array.isArray(task.user)) {
            const canApprove = checkIfCanApproveMultiple(task)

            return <p style={{color: 'black'}}>Could be approved by any of the users in position:
                <div><b>{task.position}</b>:</div> {task.user.map(u => <div>{u}</div>)}

                {canApprove &&
                <div>
                    <Form form={form}>
                        <Form.Item label={'Input the comment'} name={'comment'}>
                            <TextArea />
                        </Form.Item>
                    </Form>
                    <Button onClick={() => approveStep(task)}>Approve</Button>

                    {task.step === 0
                        ? <Button style={{marginLeft: 10}} onClick={() => cancelStep(task)}>Cancel</Button>
                        : <Button style={{marginLeft: 10}} onClick={() => rejectStep(task)}>Reject</Button>
                    }
                </div>}
            </p>
        }
    }

    const prepare = () => {
        if (current) {

            return current.map(task => {
                if (task.step_type === 'acknowledge') {
                    return null;
                }



                return {
                    icon: getIcon(task.step_type, task.step + 1),
                    description: getUserDescription(task)
                }})
        }
    }

    const assignStep = (task, user) => {
        message.info('Start assigning the step')
        const data = {
            'action': 'assign',
            user: user,
            current_user: task.user,
            current_position: task.position,
        }
        doAction(data, task)
    }

    const addStep = (task, user) => {
        message.info('Start assigning the step')
        const data = {
            'action': 'add_extra',
            user: user,
            status: task.status,
            description: task.description,
            step_type: task.step_type,
            requester: task.requester,
            min: task.min,
            max: task.max,
            appr_min: task.appr_min,
            appr_max: task.appr_max
        }
        doAction(data, task)
    }

    const getAction = (task, user) => {
        if (actionType === 'add') {
            addStep(task, user)
        } else if (actionType === 'assign') {
            assignStep(task, user)
        }

        return null
    }

    return <div>
        {isAdmin && <div>
            <Button style={{marginLeft: 10, marginBottom: 5}} onClick={() => cancelStep(current[0])}>Cancel approval</Button>
            <Button style={{marginLeft: 10, marginBottom: 5}} onClick={() => {
                setActionType('add')
                setShow(true)}
            }>Add extra person in approval</Button>
            <Button style={{marginLeft: 10, marginBottom: 20}} onClick={() => {
                setActionType('assign')
                setShow(true)
            }}>Re-assign approval</Button>
        </div>}
        <ModifyWorkflow current={current} isAdmin={isAdmin} action={getAction} show={show} setShow={setShow} />
        <Steps
            direction="vertical"
            items={currentStep}
            current={currentStep.length}
        />
    </div>
}


function ModifyWorkflow({show, setShow, action, current, isAdmin}) {

    const [email, setEmail] = useState('')
    const [form] = Form.useForm();
    const onFinish = (values) => {
        setShow(false)
        action(current[0], values['email'])
    };

    useEffect(() => {
        form.setFieldValue('email', '')
    }, [show]);


    const onOk = () => {
        form.submit()
    }

    const onCancel = () => {
        setShow(false)
    }

    return <ModalWindow isModalVisible={show} onOk={onOk} onCancel={onCancel}>
        <Form
            form={form}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
        >
            <Form.Item
                name="email"
                label="E-mail"
                rules={[
                    {
                        type: 'email',
                        message: 'The input is not valid E-mail!',
                    },
                    {
                        required: true,
                        message: 'Please input the E-mail!',
                    },
                ]}
            >
                <Input />
            </Form.Item>
        </Form>
    </ModalWindow>
}
